import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "contents px-[16px] flex" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Removendo plantões")
], -1)
const _hoisted_2 = { class: "text-base font-normal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "flex items-start gap-2 px-3 py-2 mt-4 rounded-md border border-primary30 bg-primary5 text-sm text-textPrimary text-left",
  "data-testid": "remove-bulk-station-post-station-lock-banner"
}
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col gap-4 mt-4"
}
const _hoisted_6 = { class: "mt-5 flex justify-center gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!
  const _component_ChangeReasonField = _resolveComponent("ChangeReasonField")!
  const _component_outlined_button = _resolveComponent("outlined-button")!
  const _component_filled_button = _resolveComponent("filled-button")!
  const _component_modal_vue = _resolveComponent("modal-vue")!

  return (_openBlock(), _createBlock(_component_modal_vue, {
    onClose: $setup.handleToggleModal,
    modalActive: $setup.modals[$setup.modalName],
    hasFooterBorder: true
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_outlined_button, {
          width: "119px",
          "data-testid": "remove-bulk-station-cancel-button",
          onClick: $setup.handleToggleModal,
          text: "Cancelar"
        }, null, 8, ["onClick"]),
        _createVNode(_component_filled_button, {
          loading: $setup.isLoading,
          text: "Excluir",
          width: "102px",
          "data-testid": "remove-bulk-station-confirm-button",
          onClick: $setup.handleRemove
        }, null, 8, ["loading", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_2, [
          _createTextVNode(" Tem certeza que deseja excluir " + _toDisplayString($props.totalItemsToDelete) + " " + _toDisplayString($props.totalItemsToDelete === 1 ? 'plantão' : 'plantões') + "? ", 1),
          _hoisted_3,
          _createTextVNode(" Essa ação não poderá ser desfeita! ")
        ]),
        ($setup.postStationLockMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_SVGIcon, {
                path: $setup.mdiLock,
                class: "w-4 h-4 mt-0.5 shrink-0 text-primary30"
              }, null, 8, ["path"]),
              _createElementVNode("span", null, _toDisplayString($setup.postStationLockMessage), 1)
            ]))
          : _createCommentVNode("", true),
        ($setup.reasonFields.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reasonFields, (field, index) => {
                return (_openBlock(), _createBlock(_component_ChangeReasonField, _mergeProps({
                  key: field.kind,
                  modelValue: $setup.reasonValues[field.kind],
                  "onUpdate:modelValue": ($event: any) => (($setup.reasonValues[field.kind]) = $event)
                }, field, {
                  "show-errors": $setup.showReasonErrors,
                  "scope-note": index === $setup.reasonFields.length - 1 ? $setup.reasonScopeNote : ''
                }), null, 16, ["modelValue", "onUpdate:modelValue", "show-errors", "scope-note"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onClose", "modalActive"]))
}